<div [formGroup]="formGroup" novalidate>
  <div>
    <mat-form-field>
      <input id="indflytterNavn1" aria-label="Navn" matInput placeholder="Navn" formControlName="navn" />
      @if (formGroup.controls.navn.hasError('maxlength')) {
        <mat-error> Navn er for langt. </mat-error>
      }
    </mat-form-field>
  </div>
  <div>
    <mat-form-field style="width: 300px">
      <input
        id="indflytterNavn2"
        matInput
        aria-label="Navn på ægtefælle/samlever"
        placeholder="Navn på ægtefælle/samlever"
        formControlName="navnPaaPartner"
        />
        @if (formGroup.controls.navnPaaPartner.hasError('maxlength')) {
          <mat-error> Navn er for langt. </mat-error>
        }
      </mat-form-field>
    </div>
    @if (formGroup.controls.beholdEjerAdresse.enabled) {
      <div>
        <mat-radio-group formControlName="beholdEjerAdresse">
          <mat-radio-button id="indflytterejer" value="0"> Ejer </mat-radio-button>
          <br />
          <mat-radio-button id="indflytterlejer" value="1"> Lejer </mat-radio-button>
          @if (formGroup.controls.beholdEjerAdresse.hasError('required')) {
            <mat-error> Udfyld venligst feltet. </mat-error>
          }
        </mat-radio-group>
      </div>
    }
  </div>
